/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.co.uk/privacy",
  "terms-and-conditions":
    "https://www.vodafone.co.uk/terms-and-conditions/consumer/mobile/pay-monthly/entertainment/Vodafone-entertainment/",
  "help-and-support": "https://support.vodafone.co.uk/",
  accessibility: "accessibility",
  "cookie-preferences": "cookie-preferences",
};
